import { Tooltip } from '@mui/material';
import React, { FC } from 'react';
import { Icons } from '../../../assets/SvgIcons';
import classes from './DetailScore.module.css';
type DetailScoreProps = {
  subTask?: number;
  issues?: number;
  risks?: number;
  decision?: number;
  dependency?: number;
  small?: boolean;
  color?: string;
};

const DetailScore: FC<DetailScoreProps> = ({
  subTask,
  issues,
  risks,
  decision,
  dependency,
  small,
  color,
}) => {
  return (
    <div
      className={[classes.taskIconContent, small ? classes.small : ''].join(
        ' '
      )}
    >
      {subTask !== undefined && (
        <Tooltip title="Section Total Subtask Count">
          <div className={[classes.taskIconItem, 'task-icon-item'].join(' ')}>
            <Icons.SubTaskIcon color={color || '#7D7A9A'} /> {subTask}
          </div>
        </Tooltip>
      )}
      {risks !== undefined && (
        <Tooltip title="Section Total Risk Count">
          <div className={[classes.taskIconItem, 'task-icon-item'].join(' ')}>
            <Icons.Risks20 color={color || '#7D7A9A'} /> {risks}
          </div>
        </Tooltip>
      )}
      {issues !== undefined && (
        <Tooltip title="Section Total Issue Tasks Count">
          <div className={[classes.taskIconItem, 'task-icon-item'].join(' ')}>
            <Icons.Issues20 color={color || '#7D7A9A'} /> {issues}
          </div>
        </Tooltip>
      )}

      {decision !== undefined && (
        <Tooltip title="Section Decision Tasks Count">
          <div className={[classes.taskIconItem, 'task-icon-item'].join(' ')}>
            <Icons.Decision20 color={color || '#7D7A9A'} /> {decision}
          </div>
        </Tooltip>
      )}
      {dependency !== undefined && (
        <Tooltip title="Section Dependency Tasks Count">
          <div className={[classes.taskIconItem, 'task-icon-item'].join(' ')}>
            <Icons.Dependency color={color || '#7D7A9A'} /> {dependency}
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default DetailScore;
